import { render, staticRenderFns } from "./login-demo.vue?vue&type=template&id=749bb1ce&scoped=true&"
import script from "./login-demo.vue?vue&type=script&lang=js&"
export * from "./login-demo.vue?vue&type=script&lang=js&"
import style0 from "./login-demo.vue?vue&type=style&index=0&id=749bb1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749bb1ce",
  null
  
)

export default component.exports